// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-4b4e269f] {\n  color: #e9a021;\n  cursor: default;\n}\n.text[data-v-4b4e269f] {\n  margin: 0 6px;\n}\n", ""]);
// Exports
module.exports = exports;
